export const SemiSunIcon = (): JSX.Element => (
  <svg width="411" height="207" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.903 221.979A200.002 200.002 0 0 1 205.785 24.903a200 200 0 0 1 197.076 202.881l-199.979-2.902-199.979-2.903Z"
      fill="#FDDA05"
    />
    <g filter="url(#a)">
      <ellipse
        cx="169.5"
        cy="76.69"
        rx="8.5"
        ry="7.5"
        fill="#FB9378"
        fillOpacity=".38"
      />
    </g>
    <g filter="url(#b)">
      <ellipse
        cx="234.813"
        cy="68.699"
        rx="8.5"
        ry="7.963"
        transform="rotate(-21.317 234.813 68.699)"
        fill="#FB9378"
        fillOpacity=".38"
      />
    </g>
    <path
      d="M213.404 72.19s-1.759 5.186-11.361 5.9C192.441 78.807 191 73.86 191 73.86"
      stroke="#CFB202"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="183" cy="67.19" r="2" fill="#666" />
    <circle cx="219" cy="65.19" r="2" fill="#666" />
    <defs>
      <filter
        id="a"
        x="159"
        y="67.19"
        width="21"
        height="19"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="b"
        x="222"
        y="56.19"
        width="25.627"
        height="25.017"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
    </defs>
  </svg>
);
